<template>
    <div>
        <div class="row">
            <div class="col-md-6 col-12">
                <chart-deposit></chart-deposit>
            </div>
            <div class="col-md-6 col-12">
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-12">
                <chart-contracts></chart-contracts>

            </div>
        </div>
    </div>
</template>
<script>
import ChartContracts from './components/ChartContracts.vue'
import ChartDeposit from './components/ChartDeposit.vue'
export default {
  components: { ChartDeposit, ChartContracts },
    data() {
        return{

        }
    }
}
</script>
<style scoped>

</style>